var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDateFinderSmallHomeStream(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "33px",
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDateFinderSmallHomeStream") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.4%",
    y: "-2.7%",
    width: "106.7%",
    height: "105.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.2962963,19 L36.2962963,19.2407407 C36.2962963,20.0078029 35.6744696,20.6296296 34.9074074,20.6296296 C34.1403453,20.6296296 33.5185185,20.0078029 33.5185185,19.2407407 L33.5185185,19 L28.8888889,19 L28.8888889,19.2407407 C28.8888889,20.0078029 28.2670622,20.6296296 27.5,20.6296296 C26.7329378,20.6296296 26.1111111,20.0078029 26.1111111,19.2407407 L26.1111111,19 L21.4814815,19 L21.4814815,19.2407407 C21.4814815,20.0078029 20.8596547,20.6296296 20.0925926,20.6296296 C19.3255304,20.6296296 18.7037037,20.0078029 18.7037037,19.2407407 L18.7037037,19 L17,19 C16.4477153,19 16,19.4477153 16,20 L16,22.4444444 L39,22.4444444 L39,20 C39,19.4477153 38.5522847,19 38,19 L36.2962963,19 Z M35.2962963,19 L34.5185185,19 L34.5185185,19.2407407 C34.5185185,19.4555181 34.69263,19.6296296 34.9074074,19.6296296 C35.1221848,19.6296296 35.2962963,19.4555181 35.2962963,19.2407407 L35.2962963,19 Z M27.8888889,19 L27.1111111,19 L27.1111111,19.2407407 C27.1111111,19.4555181 27.2852226,19.6296296 27.5,19.6296296 C27.7147774,19.6296296 27.8888889,19.4555181 27.8888889,19.2407407 L27.8888889,19 Z M20.4814815,19 L19.7037037,19 L19.7037037,19.2407407 C19.7037037,19.4555181 19.8778152,19.6296296 20.0925926,19.6296296 C20.30737,19.6296296 20.4814815,19.4555181 20.4814815,19.2407407 L20.4814815,19 Z M18.7037037,18 L18.7037037,17.3888889 C18.7037037,16.6218267 19.3255304,16 20.0925926,16 C20.8596547,16 21.4814815,16.6218267 21.4814815,17.3888889 L21.4814815,18 L26.1111111,18 L26.1111111,17.3888889 C26.1111111,16.6218267 26.7329378,16 27.5,16 C28.2670622,16 28.8888889,16.6218267 28.8888889,17.3888889 L28.8888889,18 L33.5185185,18 L33.5185185,17.3888889 C33.5185185,16.6218267 34.1403453,16 34.9074074,16 C35.6744696,16 36.2962963,16.6218267 36.2962963,17.3888889 L36.2962963,18 L38,18 C39.1045695,18 40,18.8954305 40,20 L40,22.4444444 L40.037037,22.4444444 L40.037037,23.4444444 L40,23.4444444 L40,39.1481481 C40,40.2527176 39.1045695,41.1481481 38,41.1481481 L17,41.1481481 C15.8954305,41.1481481 15,40.2527176 15,39.1481481 L15,23.4444444 L14.962963,23.4444444 L14.962963,22.4444444 L15,22.4444444 L15,20 C15,18.8954305 15.8954305,18 17,18 L18.7037037,18 Z M19.7037037,18 L20.4814815,18 L20.4814815,17.3888889 C20.4814815,17.1741115 20.30737,17 20.0925926,17 C19.8778152,17 19.7037037,17.1741115 19.7037037,17.3888889 L19.7037037,18 Z M27.1111111,18 L27.8888889,18 L27.8888889,17.3888889 C27.8888889,17.1741115 27.7147774,17 27.5,17 C27.2852226,17 27.1111111,17.1741115 27.1111111,17.3888889 L27.1111111,18 Z M34.5185185,18 L35.2962963,18 L35.2962963,17.3888889 C35.2962963,17.1741115 35.1221848,17 34.9074074,17 C34.69263,17 34.5185185,17.1741115 34.5185185,17.3888889 L34.5185185,18 Z M16,23.4444444 L16,39.1481481 C16,39.7004329 16.4477153,40.1481481 17,40.1481481 L38,40.1481481 C38.5522847,40.1481481 39,39.7004329 39,39.1481481 L39,23.4444444 L16,23.4444444 Z M31.9111828,27.1251515 C33.412271,28.622519 33.4123725,31.0592843 31.9111828,32.5570568 L27.5749877,36.881728 C27.4216207,37.0346838 27.2206501,37.1111111 27.0197809,37.1111111 C26.8189118,37.1111111 26.6179412,37.0346838 26.4646757,36.8818292 L22.128176,32.5572592 C21.4006218,31.8317567 21,30.8670519 21,29.8411041 C21,28.8149538 21.4006218,27.8504515 22.128176,27.1250502 C22.8555273,26.3996489 23.8227239,26 24.8514296,26 C25.6363316,26 26.3855054,26.2326224 27.0196794,26.6652717 C27.6537519,26.2327236 28.4030273,26 29.1879292,26 C30.2167365,26 31.1838315,26.3996489 31.9111828,27.1251515 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.0%",
    y: "-4.0%",
    width: "116.0%",
    height: "115.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Datefinder",
    transform: "translate(-22.000000, -550.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22-Copy-10",
    transform: "translate(11.000000, 536.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/UserProfile-Big-iphone6-Copy-3",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icDateFinderSmallHomeStream"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDateFinderSmallHomeStream);
export default __webpack_public_path__ + "static/media/icDateFinderSmallHomeStream.b2cc0ea421708abaa7ad4d21862b522c.svg";
export { ForwardRef as ReactComponent };